import { supabase } from './supabase';

async function getClientInfo() {
  try {
    const res = await fetch('https://ipapi.co/json/');
    if (!res.ok) return {};
    const j = await res.json();
    return {
      ip: j.ip || null,
      city: j.city || null,
      region: j.region || null,
      country: j.country_name || null,
      latitude: j.latitude || null,
      longitude: j.longitude || null,
    };
  } catch (e) {
    return {};
  }
}

export async function trackVisit(extra = {}) {
  // non-blocking; return promise but caller should not await if they don't want to block
  try {
    const info = await getClientInfo();
    const payload = {
      ip: info.ip || null,
      city: info.city || null,
      region: info.region || null,
      country: info.country || null,
      latitude: info.latitude || null,
      longitude: info.longitude || null,
      user_agent: navigator?.userAgent || null,
      referrer: document?.referrer || null,
      ...extra,
    };

    // fire-and-forget insert
    supabase.from('visits').insert(payload).then(() => {}).catch(() => {});
  } catch (e) {
    // swallow errors
  }
}

export async function trackYes(extra = {}) {
  try {
    const info = await getClientInfo();
    const payload = {
      ip: info.ip || null,
      city: info.city || null,
      region: info.region || null,
      country: info.country || null,
      latitude: info.latitude || null,
      longitude: info.longitude || null,
      user_agent: navigator?.userAgent || null,
      referrer: document?.referrer || null,
      ...extra,
    };

    supabase.from('yes_presses').insert(payload).then(() => {}).catch(() => {});
  } catch (e) {
    // ignore
  }
}
